// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "11a28d49f646ff3961efe30158334799f6f8c405/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};